import { bindEvents } from '../../../assets/js/helpers';

import App from '../../../assets/js/app';

import CursorController from '../../../assets/js/controller/cursor';
import SectionController from '../../../assets/js/controller/section';


const selector = 'cover-intro';

export default class CoverIntro {

	constructor(section) {
		this.el = {
			section,
			fillSVGs: section.querySelectorAll(`.${selector}__svg-text-fill svg`),
			cover: section.querySelector(`.${selector}__cover figure`)
		};

		this.el.video = document.createElement('video');
		this.el.video.muted = true;
		this.el.video.playsinline = true;
		this.el.video.loop = true;
		this.el.video.setAttribute('muted', 'muted');
		this.el.video.setAttribute('playsinline', 'playsinline');
		this.el.video.setAttribute('loop', 'loop');
		this.el.video.src = `${this.el.cover.dataset.videoSource}-${(window.innerWidth < 1280 ? 50 : 100)}.mp4`;
		this.el.cover.appendChild(this.el.video);

		this.holding = false;
		this.continue = false;

		this.timeout = null;

		this.callback = null;

		this.events = bindEvents(this);

		this.addEventListeners();
	}

	static get selector() {
		return selector;
	}

	_onDocumentMouseUp() {
		if (this.holding) {
			this.holding = false;
			if (!this.continue) this.el.section.classList.remove('fill-svgs');
		}
	}

	_onSectionMouseDown(e) {
		e.preventDefault();
		this.holding = true;
		this.el.section.classList.add('fill-svgs');
	}

	_onSectionClick() {
		if (App.touch) {
			this.holding = true;
			this.el.section.classList.add('fill-svgs');
			App.startBackgroundAudio();
		}
	}

	_onfillSVGTransitionEnd(e) {
		if (!this.continue && this.holding && (e.propertyName === 'transform' || e.propertyName === '-webkit-transform')) {
			this.continue = true;
			this.el.section.classList.add('showing-content');
			this.timeout = setTimeout(() => {
				document.documentElement.classList.remove('showing-intro');
				CursorController.cancelHijack('press-hold');
				SectionController.globals['fixed-header'].show();
				if (this.callback) this.callback();
			}, 1000);
		}
	}

	addEventListeners() {
		document.addEventListener('mouseup', this.events._onDocumentMouseUp);
		document.addEventListener('touchend', this.events._onDocumentMouseUp);

		this.el.section.addEventListener('mousedown', this.events._onSectionMouseDown);
		this.el.section.addEventListener('click', this.events._onSectionClick);
		for (const fs of this.el.fillSVGs) fs.addEventListener('transitionend', this.events._onfillSVGTransitionEnd);
	}

	removeEventListeners() {
		document.removeEventListener('mouseup', this.events._onDocumentMouseUp);
		document.removeEventListener('touchend', this.events._onDocumentMouseUp);

		this.el.section.removeEventListener('mousedown', this.events._onSectionMouseDown);
		this.el.section.removeEventListener('click', this.events._onSectionClick);
		for (const fs of this.el.fillSVGs) fs.removeEventListener('transitionend', this.events._onfillSVGTransitionEnd);
	}

	destroy() {
		if (this.timeout) clearTimeout(this.timeout);
		this.removeEventListeners();
	}

}
